export const IPC_FUNCTION_TAG_PROPERTY = '__ipc_function__';
export const IPC_FUNCTION_TAG_VALUE = 0xfc0de; // Magic number
